import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/team/roles')({
  component: () => <PageStub title="Roles & Duties" description="Role definitions and responsibilities" />,
});
